import React from 'react';
import { Box, Container } from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';

export default function OperatorGuide() {

  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';
  const pdfRoute = 'documents/UserGuide.pdf';
  const route = baseRoute + pdfRoute;

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="Operator Guide"></PageHeader>
      </Box>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            mt: '40px',
            height: '968px',
            width: '1444px'
          }}
        >
          <iframe
            src={route}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: 'none', display: 'block', margin: '0 auto' }}
          />
        </Box>
      </Box>
    </Container>
  );
};
